// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"95679d02","215":"298fde6a","441":"41fca3df","498":"5057a7e8","513":"e7769041","787":"e48f94a7"}[chunkId] + ".chunk.js";
};